export default __webpack_public_path__ + "static/media/holytrinity.400f95b7.jpg";